import React from 'react';
import { CountdownTimer } from './CountdownTimer';
export function FinalCTA() {
  return <section className="py-20 bg-ocean-teal text-white relative overflow-hidden" data-id="element-60">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-10 pointer-events-none" data-id="element-61">
        <div className="absolute -top-24 -left-24 w-96 h-96 rounded-full bg-white blur-3xl" data-id="element-62"></div>
        <div className="absolute bottom-0 right-0 w-full h-1/2 bg-gradient-to-t from-ocean-teal-dark to-transparent" data-id="element-63"></div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-64">
        <h2 className="text-3xl md:text-5xl font-bold mb-6 text-white leading-tight" data-id="element-65">
          SISTEMA 360 NAIL ARTIST
        </h2>

        <p className="text-lg md:text-xl text-ocean-teal-light mb-10 max-w-2xl mx-auto" data-id="element-66">
          El próximo fin de semana podés seguir improvisando y perdiendo plata.
          O podés tener tu negocio ordenado desde hoy.
        </p>

        <div className="mb-10" data-id="element-67">
          <p className="text-sm font-bold text-ocean-gold-light uppercase tracking-wider mb-4" data-id="element-68">
            ⏰ El precio de lanzamiento cierra en:
          </p>
          <div className="bg-white/10 p-6 rounded-2xl inline-block backdrop-blur-sm border border-white/20" data-id="element-69">
            <CountdownTimer data-id="element-70" />
          </div>
          <p className="text-ocean-teal-light mt-4 font-medium" data-id="element-71">
            Después sube el precio y no vuelve.
          </p>
        </div>

        <div className="bg-white rounded-3xl p-8 md:p-10 mb-10 border border-white/20 max-w-md mx-auto text-center shadow-2xl" data-id="element-72">
          <div className="text-ocean-teal-dark font-bold text-xl mb-2" data-id="element-73">
            🏆 PACK COMPLETO ⭐
          </div>
          <p className="text-gray-600 mb-6" data-id="element-74">6 tomos + 6 bonos + Acelerador</p>

          <div className="text-4xl font-bold text-gray-900 mb-8" data-id="element-75">$27.990</div>

          <a href="https://www.tera-ventasonline.shop/cart/45111856431219:1" target="_blank" rel="noopener noreferrer" className="w-full py-4 px-8 bg-ocean-gold hover:bg-ocean-gold-dark text-white rounded-xl font-bold text-lg transition-colors shadow-lg flex items-center justify-center gap-2" data-id="element-76">
            → QUIERO MI SISTEMA COMPLETO
          </a>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6 text-sm text-ocean-teal-light font-medium" data-id="element-77">
          <span className="flex items-center gap-1.5" data-id="element-78">🔒 Pago 100% seguro</span>
          <span className="hidden sm:inline" data-id="element-79">•</span>
          <span className="flex items-center gap-1.5" data-id="element-80">
            ⚡ Acceso en 5 minutos
          </span>
          <span className="hidden sm:inline" data-id="element-81">•</span>
          <span className="flex items-center gap-1.5" data-id="element-82">
            🛡️ Garantía 7 días sin preguntas
          </span>
        </div>

        <div className="mt-6 text-xs text-ocean-teal-light/70 flex items-center justify-center gap-2" data-id="element-83">
          💳 Mercado Pago | Tarjeta de crédito | Transferencia bancaria
        </div>
      </div>
    </section>;
}